<template>
  <div class="select-component" v-invalid="validation.is_valid">
    <div class="field" :class="getFieldClass(field.layout)">
      <label class="label"
             v-if="field.label"
             :class="getLabelClass(field.layout)"
             :for="field.id">
        <span>
          {{ field.label }}
        </span>
      </label>
      <div class="control" :class="getControlClass(field.layout)">
        <span class="select"
              :class="getInputClass(validation.is_valid)"
              v-if="!field.properties.input_readonly">
          <select v-model="field.value"
                  @change="validate()"
                  :id="field.id"
                  :multiple="field.properties.multiple_options"
                  :name="field.id">
            <option v-for="(option, key) in field.properties.options"
                    :value="option.value"
                    :key="key">
              {{ option.display }}
            </option>
          </select>
        </span>

        <input class="input" type="text" v-else
               :id="field.id"
               :name="field.id"
               :readonly="true"
               :value="getInputReadonlyValue(field.value)">

        <p class="help is-danger"
           v-if="!validation.is_valid">
          {{ validation.message }}
        </p>
        <p class="help"
           v-if="field.properties.help_text"
           v-html="field.properties.help_text">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'select-component',
    data () {
      return {
        validation: {
          is_valid: true
        }
      }
    },
    props: {
      field: {
        type: Object,
        default: () => ({
          properties: {}
        })
      }
    },
    methods: {
      validate () {
        if (!this.field.validation) return
        if (this.validation.is_required) {
          this.validation.is_valid = !!this.field.value
        }
        Object.assign(this.field.validation, this.validation)
      },
      getFieldClass (layoutType) {
        return {
          'columns is-multiline is-mobile': layoutType === 'horizontal'
        }
      },
      getLabelClass (layoutType) {
        return {
          'column is-4': layoutType === 'horizontal'
        }
      },
      getControlClass (layoutType) {
        return {
          'column is-8': layoutType === 'horizontal'
        }
      },
      getInputClass (isValid) {
        return {
          'is-danger': !isValid
        }
      },
      getInputReadonlyValue (value) {
        let option = this.field.properties.options.find(option => option.value === value)
        return option ? option.display : null
      }
    },
    created () {
      Object.assign(this.validation, this.field.validation || {})
      this.field.eventBus && this.field.eventBus.$on('validate', this.validate)
    }
  }
</script>

<style lang="sass" scoped>
  label > li
    list-style-position: inside

  span
    width: 100%

  select
    width: 100%

</style>
